import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog'

export function TermsAlert({ setter, reference }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger ref={reference}></AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Agree to our terms of service</AlertDialogTitle>
          <AlertDialogDescription>
            By agreeing, you are confirming that you have read and understood
            our{' '}
            <a
              target="_blank"
              className="text-shades-0 underline"
              href="/support/livery-buyers-terms"
            >
              terms of service.
            </a>
            , and can therefore proceed with downloading this livery.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => setter(false)}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction onClick={() => setter(true)}>
            Agree and continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
